import { render, staticRenderFns } from "./about-view.vue?vue&type=template&id=6aab78d0&scoped=true&"
import script from "./about-view.vue?vue&type=script&lang=js&"
export * from "./about-view.vue?vue&type=script&lang=js&"
import style0 from "./about-view.vue?vue&type=style&index=0&id=6aab78d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aab78d0",
  null
  
)

export default component.exports